import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { imsiColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import { __getIMSI } from "../../../../api/sim";

const COPY_KEYS = ["id", "batch_id", "imsi", "status", "last_updated"];

const IMSIBatch = ({ operation }) => (
  <BatchDetail
    title="IMSI"
    apiGet={__getIMSI}
    client={CLIENTS.sparq}
    columnsFactory={imsiColumns}
    copyKeys={COPY_KEYS}
    exportAction={operation}
    retryOperation={operation}
    showTerminate
    getRowPath={(row) => `/sparq/imsi/${operation}/${row.id}`}
  />
);

export default IMSIBatch;
